import SquareAd from '@components/Advertisements/SquareAd';
import { BoatDocuments } from '@components/BoatDocuments';
import styles from '@styles/SingleBoat/index.module.scss';
import { getBoatName } from '@utils/getBoatName';
import { Alert } from 'antd';
import { FC, useState } from 'react';
import { Boat } from 'services/graphql/cms';
import { useSubscription } from 'services/hooks/queries/useSubscription';
import BoatDescription from './BoatDescription/BoatDescription';
import BoatOverview from './BoatOverview';
import { BoatOverviewMenu, BoatTable as boatTable } from './boatMenus';
import DetailTable from './DetailTable';
import Jumbotron from './Jumbotron';
import OverviewAnchor from './OverviewAnchor';

type Props = {
  boat: Boat;
};

const SingleBoat: FC<Props> = ({ boat }) => {
  const { isSubscribed } = useSubscription();

  const [jumbotronHeight, setJumbotronHeight] = useState<number>(192);
  const boatTitle = getBoatName(boat);
  const detailTable = boatTable(boat);

  // const relatedBoatsVariables: GetRelatedUsersBoatsVariables = {
  //   id: boat?.id,
  //   limit: 10,
  // };

  // const { data: relatedUsersBoats, isFetching: isLoadingRelatedBoats } = useRelatedUsersBoats(relatedBoatsVariables);

  // const discoverBoats = useMemo(() => {
  //   if (relatedUsersBoats && Object.keys(relatedUsersBoats).length && relatedUsersBoats?.relatedUsersBoats.length) {
  //     return relatedUsersBoats?.relatedUsersBoats.map((userBoat) => ({
  //       id: userBoat?.boat?.id,
  //       cover: userBoat?.boat?.image?.thumbnails?.sm,
  //       statistic: {
  //         view: userBoat?.boat?.views_count,
  //         save: userBoat?.boat?.favorites_count,
  //       },
  //       user: {
  //         name: userBoat?.user.name,
  //         fullName: `${userBoat?.user.name} ${userBoat?.user.surname}`,
  //         image: null,
  //       },
  //       details: {
  //         desc: `${userBoat?.boat?.year_first} ${userBoat?.boat?.model} ${userBoat?.boat?.manufacturer_name}`,
  //         title: userBoat?.boat?.manufacturer_name,
  //         url: `/boat/${userBoat?.boat?.slug}`,
  //         flag: userBoat?.flag,
  //         isFav: userBoat?.boat?.is_favorited,
  //       },
  //     }));
  //   }

  //   return [];
  // }, [relatedUsersBoats]);

  // const discoverBoatsDesc = formatMessage(
  //   {
  //     id: `single_boat.discover_user_boats.desc.${
  //       discoverBoats
  //         ? discoverBoats.length !== 0
  //           ? discoverBoats.length > 3
  //             ? '3'
  //             : discoverBoats.length
  //           : '1'
  //         : '1'
  //     }`,
  //   },
  //   (() => {
  //     const variables = {
  //       firstUser: '',
  //       secondUser: '',
  //       publicBoatCount: discoverBoats.length,
  //     };

  //     if (discoverBoats && discoverBoats.length !== 0) {
  //       switch (discoverBoats.length) {
  //         case 1:
  //           variables.firstUser = discoverBoats[0].user.name;
  //           break;

  //         case 2:
  //           variables.firstUser = discoverBoats[1].user.name;
  //           break;

  //         default:
  //           variables.firstUser = discoverBoats[0].user.name;
  //           variables.firstUser = discoverBoats[1].user.name;
  //           break;
  //       }
  //     }

  //     return variables;
  //   })(),
  // );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  // const ids = useMemo(() => selectedBoats.map((item) => parseInt(item.id, 10)), []);

  // const { data: boats } = useMultipleBoats({ ids }, { fetchMultipleBoats: selectedBoats });

  const _handleAddBoat = () => {
    // addBoat(boat);
  };

  const _handleRemoveBoat = () => {
    // removeBoat(boat?.attributes?.slug);
  };

  return (
    <>
      <Jumbotron pageName="single_boat" breadCrumb={[0]} setJumbotronHeight={setJumbotronHeight} boat={boat} />
      <BoatOverview
        boatName={boatTitle}
        image={boat?.image}
        files={boat?.files}
        menuItems={BoatOverviewMenu(boat, jumbotronHeight)}
      />
      {boat?.enable_description && boat?.description && <BoatDescription description={boat?.description} />}
      {!!boat.documents.length && <BoatDocuments documents={boat.documents} />}

      <section className={styles.container} id="single-public-boat-content">
        <div className={styles.container__content}>
          <div className={styles.container__content__sticky}>
            <OverviewAnchor details={detailTable} jumbotronHeight={jumbotronHeight} />
            {!isSubscribed ? <SquareAd /> : null}
          </div>
        </div>
        <div className={styles.container__tables}>
          {detailTable.map((items) => (
            <DetailTable key={items.title} {...items} />
          ))}

          {boat?.notes ? (
            <Alert
              message="Notes"
              description={<div dangerouslySetInnerHTML={{ __html: `${boat?.notes}` }} />}
              type="info"
              showIcon
              className={styles.notes}
            />
          ) : null}
        </div>
      </section>
    </>
  );
};

export default SingleBoat;
